import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SanitizeInputDirective } from '../directives/shared/sanitize-input.directive';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AgGridTableComponent } from './components/ag-grid-table/ag-grid-table.component';
import { ActionRendererComponent } from './components/action-renderer/action-renderer.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';



@NgModule({
  declarations: [SanitizeInputDirective,AgGridTableComponent,
          ActionRendererComponent],
  imports: [
    CommonModule,
    NgSelectComponent,
    AgGridModule
  ],
  exports: [
    SanitizeInputDirective,
    NgSelectComponent,
    AgGridTableComponent,
  ActionRendererComponent     
  ]
})
export class SharedModule { }
